const IsVisibleSection = ({ isMobile, isOpen, children }) => {
	if (!isMobile || isOpen) {
		return <>{children}</>;
	}
	return null;
};

export default IsVisibleSection;
